enum CctvActionNames {
  CAMERA_INDEX = 'cameraIndex',
  STREAM_INDEX = 'streamIndex',
  STREAM_DELETE = 'streamDelete',
}

export default CctvActionNames;
